import User from '@/modules/models/User'
import * as iotServicesSdk from 'iot-services-sdk';
import { StatefulSetInterval } from '../../utils/StatefulSetInterval';

const state = {
    user: null,
    loginInRun:false,
    logoutTimer: null,
    credentials: null
}

const getters = {
    getUserName(state){
        if(state.user)
        if(state.user.username)
            return state.user.username
        else
            return state.user.email
    },
    isLoggedIn (state) {
        return state.user != null && state.user!=undefined
    },
    getLoginInRun(state){
        return state.loginInRun
    }
}

const actions = {
    init({commit, dispatch, rootState}){
        return new Promise(
            async (resolve,reject)=>{
                try{
                    let user = await rootState.serviceModule.authentication.CheckLogin();
                    
                    if(user){
                        rootState.serviceModule.analytics.setUser(user.credentials.sub,user.email)    
                        commit('setAuthData', user)
                        commit('setCredentials', user.credentials)
                        let now = (new Date()).getTime()   
                        let expirationDateMillis = Math.floor((user.credentials.expiration - now)/2) 
                        
                        let logoutTimerId = setInterval(async ()=>{
                            
                            await dispatch('refresh')
                            // TODO: move on root store
                            await rootState.serviceModule.deviceManager.StopListenRealtimeData()
                            await rootState.serviceModule.deviceManager.StartListenRealtimeData(
                                rootState.onClose,
                                rootState.onMessage,
                            )

                        },expirationDateMillis)
                        commit('setLogoutTimer', logoutTimerId)
                    }
                    resolve()
                }catch(e){
                    reject(e);
                }
            }
        )
    },

    signup({commit, dispatch, rootState}, user){
        let userModel = 
            new User(
                user.email,
                user.password,
                user.username
            )

        return new Promise(
            function(resolve,reject){
                commit('startLoginInRun')
                commit('startOperation','Creating account',{root:true})
                rootState.serviceModule.authentication.CreateUser(userModel)
                    .then(
                        ()=>{
                            dispatch('login',userModel)
                            .then( () => resolve())
                            .catch( ()=> reject())
                        } 
                    )
                    .catch(
                        ()=>{
                            commit('stopOperation',null,{root:true})
                            commit('errorLastOperationPerformed','Creating failed')
                            commit('stopLoginInRun')
                            reject() 
                        }
                    )
            }
        )
    },


    login({dispatch, commit, rootState}, user){
        let userModel = null
        let type = null
        if(user){
            type = "google"
            if((typeof user)=="object")
                userModel = 
                    new User(
                        user.email,
                        user.password,
                        user.username
                    )
            else
                type = user
        }
        
        return new Promise(
            function(resolve,reject){
                commit('startLoginInRun')
                commit('startOperation','Login',{root:true})
                rootState.serviceModule.authentication.Login(userModel,type)
                    .then(
                        (filledUserModel)=>{
                            if(!filledUserModel) {
                                reject()
                                return;
                            }
                            
                            commit('setAuthData', filledUserModel)
                            commit('setCredentials', filledUserModel);
                            commit('stopOperation',null,{root:true})
                            commit('successLastOperationPerformed','Login success',{root:true})
                            let now = (new Date()).getTime()  
                            let expirationDateMillis = Math.floor(( filledUserModel.credentials.expiration - now  )/2)                  
                            let logoutTimerId = setInterval(async ()=>{
                                // dispatch('logout')
                                await dispatch('refresh')
                                
                                // TODO: move on root store
                                await rootState.serviceModule.deviceManager.StopListenRealtimeData()
                                await rootState.serviceModule.deviceManager.StartListenRealtimeData(
                                    rootState.onClose,
                                    rootState.onMessage,
                                )
                            },expirationDateMillis)
                            commit('setLogoutTimer', logoutTimerId)
                            commit('stopLoginInRun');

                            rootState.serviceModule.analytics.setUser(filledUserModel.credentials.sub,filledUserModel.email)    
                            resolve()                            
                        }
                    )
                    .catch(
                        (err)=>{
                            commit('stopOperation',null,{root:true})
                            commit('errorLastOperationPerformed','Login failed: '+err,{root:true})
                            commit('stopLoginInRun')
                            reject(err)                            
                        }
                    )
            })
    },

    refresh({commit, rootState}){
        return new Promise(
            function(resolve, reject){
                commit('startLoginInRun')  
                commit('startOperation','Refreshing account credentials',{root:true})              
                rootState.serviceModule.authentication.RefreshCredentials()
                    .then(
                        (data)=>{
                            
                            commit('stopOperation',null,{root:true})
                            // commit('clearAuthData')
                            commit('successLastOperationPerformed','Refresh success',{root:true})
                            commit('stopLoginInRun')
                            resolve(data)                            
                        }
                    )
                    .catch(
                        (err)=>{
                            commit('stopOperation',null,{root:true})
                            commit('errorLastOperationPerformed','Refresh failed',{root:true})
                            commit('stopLoginInRun')
                            reject(err)                            
                        }
                    )
            })
    },


    logout({commit, rootState}){
        return new Promise(
            function(resolve, reject){
                commit('startLoginInRun')  
                commit('startOperation','Logout account',{root:true})              
                rootState.serviceModule.authentication.Logout()
                    .then(
                        (data)=>{
                            commit('stopOperation',null,{root:true})
                            commit('clearAuthData')
                            commit('successLastOperationPerformed','Logout success',{root:true})
                            commit('stopLoginInRun')
                            resolve(data)                            
                        }
                    )
                    .catch(
                        (err)=>{
                            commit('stopOperation',null,{root:true})
                            commit('errorLastOperationPerformed','Logout failed',{root:true})
                            commit('stopLoginInRun')
                            reject(err)                            
                        }
                    )
            })
    },

    acceptLA({commit, rootState}){
        return new Promise(
            function(resolve,reject){
                commit('startOperation','Login',{root:true})
                rootState.serviceModule.authentication.AcceptLA()
                .then(
                    (data)=>{
                        commit('stopOperation',null,{root:true})
                        commit('successLastOperationPerformed','LA accepted',{root:true})
                        resolve(data)                            
                    }
                )
                .catch(
                    (err)=>{
                        commit('stopOperation',null,{root:true})
                        commit('errorLastOperationPerformed','LA accepting failed',{root:true})
                        reject(err)                            
                    }
                )
            }
        )
    }
}

const mutations = {
    setCredentials(state, user){
        state.credentials = new iotServicesSdk.shared.auth.sigv4.SigV4Crendentials(user.sessionToken, user.secretAccessKey, user.accessKeyId)
    },
    setAuthData(state,user){
        state.user = user
    },
    clearAuthData(state){
        state.user = null 
    },
    startLoginInRun(state){
        state.loginInRun = true
    },
    stopLoginInRun(state){
        state.loginInRun = false
    },
    setLogoutTimer (state, logoutTimerId) {
        clearTimeout(state.logoutTimerId)
        state.logoutTimerId = logoutTimerId
    }
}

export default{
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    namespaced:true
}